var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { createUseStyles } from 'react-jss';
import Shortcut from '../Shortcut/Shortcut';
import { Grid, GridItem } from '@patternfly/react-core';
const useStyles = createUseStyles({
    shortcutGridItem: {
        textAlign: 'right',
        marginRight: 'var(--pf-v5-global--spacer--sm)'
    }
});
const ShortcutGrid = (_a) => {
    var { shortcuts, gridItemProps } = _a, rest = __rest(_a, ["shortcuts", "gridItemProps"]);
    const classes = useStyles();
    return (React.createElement(Grid, Object.assign({ span: 6, hasGutter: true, key: "grid" }, rest), shortcuts.map((shortcut, index) => {
        const { description } = shortcut, props = __rest(shortcut, ["description"]);
        return (React.createElement(React.Fragment, { key: index },
            React.createElement(GridItem, Object.assign({ className: classes.shortcutGridItem }, gridItemProps),
                React.createElement(Shortcut, Object.assign({}, props))),
            React.createElement(GridItem, null, description)));
    })));
};
export default ShortcutGrid;
